export default function TextField(theme) {
  return {
    MuiTextField: {
      defaultProps: {
        sx: {
          '& .MuiInputBase-input::placeholder': {
            color: theme.palette.text.secondary,
            WebkitTextFillColor: theme.palette.text.secondary,
            opacity: 1,
          },
        },
      },
    },
  }
}
